import React from "react";

const ProgramPolicy = () => {
  return (
    <div className="max-w-5xl mx-auto p-8">
      <h1 className="text-3xl font-bold mb-6">
        EarnProjectAcademy – Program Terms & Student Guidelines
      </h1>

      <h2 className="text-xl font-semibold mt-6">1. Registration Fee</h2>
      <p>
        The registration fee reserves your seat in the program and is
        non-refundable. This amount will be adjusted against the total course
        fee. Students must confirm their admission within 5 days of making the
        registration payment by completing the full payment or partial payment.
        Failure to confirm admission within this period may lead to seat release
        and forfeiture of the registration fee.
      </p>

      <h2 className="text-xl font-semibold mt-6">2. Minimum System Requirements</h2>
      <ul className="list-disc ml-6">
        <li>Intel i3/i5/i7 processor with minimum 2.0 GHz</li>
        <li>Minimum 4GB RAM (8GB recommended)</li>
        <li>Stable high-speed internet connection</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6">3. Class Timings & Scheduling</h2>
      <p>
        Classes will follow the scheduled modules. EarnProjectAcademy aims to
        complete the program within the planned duration. In case of unforeseen
        delays such as instructor availability or batch pace, the program may
        extend without additional charges. Career guidance sessions will be
        provided toward the end of the program.
      </p>

      <h2 className="text-xl font-semibold mt-6">4. Tools Used</h2>
      <p>
        Wherever possible, open-source tools will be used. If premium tools are
        introduced, students may use available trial versions. EarnProjectAcademy
        does not provide paid licenses.
      </p>

      <h2 className="text-xl font-semibold mt-6">5. LMS Access</h2>
      <p>
        Students will receive LMS access for up to 2 years from the course start
        date. LMS access is not lifelong and may be revoked in case of policy
        violations or payment defaults.
      </p>

      <h2 className="text-xl font-semibold mt-6">6. Student Query Resolution</h2>
      <p>
        Support hours are Monday to Saturday, 09:00 AM to 06:00 PM IST. Most
        queries are resolved within 24 hours depending on request volume.
      </p>

      <h2 className="text-xl font-semibold mt-6">7. Batch Transfer Policy</h2>
      <ul className="list-disc ml-6">
        <li>One-time free batch transfer within 30 days of course start</li>
        <li>After 30 days: ₹3000 transfer fee</li>
        <li>Completed batch requires re-enrollment with 25% program fee</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6">8. Pause Policy</h2>
      <p>
        Students may pause the program for up to 2 months during the course
        duration. Beyond this period, re-enrollment may be required.
      </p>

      <h2 className="text-xl font-semibold mt-6">9. Fee Payment & EMI Terms</h2>
      <p>
        EMI payments must be completed in consecutive months. A 7-day grace
        period is allowed. Late payments beyond this period may incur penalties
        and LMS access suspension.
      </p>

      <h2 className="text-xl font-semibold mt-6">10. Loan Policy</h2>
      <p>
        Loan agreements are between the student and the loan provider.
        EarnProjectAcademy is not responsible for disputes related to loans.
      </p>

      <h2 className="text-xl font-semibold mt-6">11. Faculty & Content</h2>
      <p>
        Sessions are conducted by experienced industry experts. LMS content
        cannot be downloaded or redistributed without permission.
      </p>

      <h2 className="text-xl font-semibold mt-6">12. Access to Recordings</h2>
      <p>
        Students will have access to class recordings through the LMS during the
        course period.
      </p>

      <h2 className="text-xl font-semibold mt-6">13. Certification</h2>
      <p>
        Certificates will be issued only to enrolled students who complete the
        course requirements.
      </p>

      <h2 className="text-xl font-semibold mt-6">14. Discontinuation Policy</h2>
      <p>
        EarnProjectAcademy may discontinue programs due to operational or
        strategic reasons. Students may be offered alternative programs subject
        to seat availability.
      </p>

      <h2 className="text-xl font-semibold mt-6">15. Intellectual Property</h2>
      <p>
        All course materials including videos, documents, and projects are the
        intellectual property of EarnProjectAcademy and cannot be shared,
        copied, or distributed.
      </p>

      <h2 className="text-xl font-semibold mt-6">16. False Information Policy</h2>
      <p>
        Providing false personal or academic information may result in
        cancellation of enrollment without refund.
      </p>

      <h2 className="text-xl font-semibold mt-6">17. Disclaimer</h2>
      <p>
        EarnProjectAcademy reserves the right to modify course content,
        schedules, instructors, or structure as required.
      </p>

      <h2 className="text-xl font-semibold mt-6">Contact Information</h2>
      <p>Email: info@earnprojectacademy.com</p>
      <p>Website: https://earnprojectacademy.com</p>
    </div>
  );
};

export default ProgramPolicy;